import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/empty';

import { WrapperService } from '../api/wrapper.service';
import { LOADER_SERVICE } from '../shared/upgrade/loader.service';

@Injectable()
export class ReportsService {

	constructor(private wrapper: WrapperService) {
	}

	public getTimecards(startDate: string, endDate: string, employees?: number[]): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/timecards', { startDate: startDate, endDate: endDate, employees: employees }, 'getTimecards');
	}

	public getSubmittedTimecards(startDate: string, endDate: string, employees?: number[]): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/timecards/submitted', { startDate: startDate, endDate: endDate, employees: employees }, 'getSubmittedTimecards');
	}

	public getTimecardRowsForRange(startDate: string, endDate: string, employees?: number[]): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/timecardrow/getTimecardRowsForRange', { startDate: startDate, endDate: endDate, employees: employees }, 'getSubmittedTimecards');
	}

	public updateTimecardRowNote(employeeId: number, date: string, note: string): Observable<any> {
		return this.wrapper.wrapPostRequest(`/reports/timecardrow/note`, { employee: employeeId, date: date, note: note }, 'updateTimecardRowNote');
	}

	public updateTimecardRowBillingUnits(employeeId: number, date: string, billingUnits: number): Observable<any> {
		return this.wrapper.wrapPostRequest(`/reports/timecardrow/billingUnits`, { employeeId: employeeId, date: date, billingUnits: billingUnits }, 'updateTimecardRowBillingUnits');
	}

	public submitTimecardToApproval(employeeId: string, startDate: string, endDate: string, sequenceId: string, billingUnitsTotal: number): Observable<any> {
		const data: any = {
			startDate: startDate,
			endDate: endDate,
			employeeId: employeeId,
			sequenceId: sequenceId,
			billingUnitsTotal: billingUnitsTotal
		};
		return this.wrapper.wrapPostRequest(`/reports/timecards/submit`, data, 'submitTimecardToApproval');
	}


	public unsubmitUnapprovedTimecard(timecardId: number): Observable<any> {
		return this.wrapper.wrapDeleteRequest(`/reports/timecards/submit/${timecardId}`, null, 'unsubmitUnapprovedTimecard');
	}

	public submitTransactionEmailReport(transactionId: string, email: string): Observable<any> {
		const data: any = {
			transactionId: transactionId,
			email: email
		};
		return this.wrapper.wrapPostRequest(`/reports/paymentReport`, data, 'submitTransactionEmailReport');
	}

	public submitTimecardTransactionDetails(timecardId: number, employeeId: string, transactionId: string, sequenceId: string, startDate: string, endDate: string, dates: any[], billingUnitsTotal: number): Observable<any> {
		const data: any = {
			id: timecardId,
			startDate: startDate,
			endDate: endDate,
			employeeId: employeeId,
			transactionId: transactionId,
			sequenceId: sequenceId,
			dates: dates,
			billingUnitsTotal: billingUnitsTotal
		};
		return this.wrapper.wrapPostRequest(`/reports/timecards/submit/approved`, data, 'submitTimecardTransactionDetails');
	}

	public getAnnualReport(dates: string[], employees: number[], includeDisabled: boolean): Observable<any> {
		const data: any = {
			dates: dates,
			employees: employees,
			includeDisabled: includeDisabled
		};

		return this.wrapper.wrapPostRequest('/reports/annualTotals/range', data, 'getAnnualReport');
	}

	public getAnnualReportByEmployeeType(data: any): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/annualTotals/range/employeeType', data, 'getAnnualReportByEmployeeType');
	}


}



// WEBPACK FOOTER //
// ./src/app/reports/reports.service.ts